import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const multiSelectTemplate = htmlE`
  ${({
    id,
    leftLabel,
    rightLabel,
    filterText,
    clearText,
    selectText,
    allText,
    noneText,
    addSelectedText,
    removeSelectedText,
  }) => {
    return `<div${id ? ` id='${id}'` : ""} class="multiselect-wrapper">
        <div class="is-flex">
        <div class="is-flex is-flex-direction-column gap-2 left-column multi-select-columns add-right-border pr-3">

          <div class="bg-accentSecondary">
            <p data-i18n-key="${leftLabel}" class="has-text-weight-semibold px-3 py-1 text-sm">${leftLabel}</p>
          </div>

          <div>
            <div class="bg-primaryMain is-flex is-align-items-center is-flex-wrap-wrap">
                <div class="is-flex gap-3 is-align-items-center bg-primaryMain is-relative">
                    <label class="text-sm text-primaryMain" data-i18n-key="filter">${filterText}
                    </label>
                    <input class="input bg-primaryMain modal-input left-filter-input" type="text" autocomplete="off">
                    <button type="button" data-i18n-key="clear" class="primary-button is-bg-none p-0 left-clear-filter-btn">${clearText}</button>
                </div>
            </div>
          </div>

          <div class="is-flex is-justify-content-space-between">

            <div class="is-flex gap-2">

              <span data-i18n-key="select" class="text-sm">${selectText}</span><span class="text-sm"> : </span>

              <div class="is-flex gap-2">
                <button
                  tabindex="0"
                  type="button"
                  class="primary-button is-bg-none p-0 select-all-left"
                  aria-label="select-all-btn"
                >
                  <span data-i18n-key="all">${allText}</span>
                </button>

                <div class="add-right-border"></div>

                <button
                  tabindex="0"
                  type="button"
                  class="primary-button is-bg-none p-0 select-none-left"
                  aria-label="select-none-btn"
                >
                  <span data-i18n-key="none">${noneText}</span>
                </button>

              </div>

            </div>

            <div>
                <button
                    tabindex="0"
                    type="button"
                    class="primary-button is-bg-none p-0 left-column-add-selected-btn"
                    aria-label="add-selected-btn"
                >
                    <span data-i18n-key="addSelected">${addSelectedText}</span>
                </button>
            </div>
          </div>

          <select multiple class="left-side-options multiselect-options-wrapper">
          </select>
        </div>

        <div class="is-flex is-flex-direction-column gap-2 right-column multi-select-columns pl-3">

            <div class="bg-accentSecondary">
                <p data-i18n-key="${rightLabel}" class="has-text-weight-semibold px-3 py-1 text-sm">${rightLabel}</p>
            </div>

        <div>
            <div class="bg-primaryMain is-flex is-align-items-center is-flex-wrap-wrap">
                <div class="is-flex gap-3 is-align-items-center bg-primaryMain is-relative">
                    <label class="text-sm text-primaryMain" data-i18n-key="filter">${filterText}
                    </label>
                    <input class="input bg-primaryMain modal-input right-filter-input" type="text" autocomplete="off">
                    <button type="button" data-i18n-key="clear" class="primary-button is-bg-none p-0 right-clear-filter-btn">${clearText}</button>
                </div>
            </div>
        </div>

      <div class="is-flex is-flex-direction-row-reverse is-justify-content-space-between">

      <div class="is-flex gap-2">

          <span data-i18n-key="select" class="text-sm">${selectText}</span><span class="text-sm"> : </span>

          <div class="is-flex gap-2">
            <button
              tabindex="0"
              type="button"
              class="primary-button is-bg-none p-0 select-all-right"
              aria-label="select-all-btn"
            >
              <span data-i18n-key="all">${allText}</span>
            </button>

            <div class="add-right-border"></div>

            <button
              tabindex="0"
              type="button"
              class="primary-button is-bg-none p-0 select-none-right"
              aria-label="select-none-btn"
            >
              <span data-i18n-key="none">${noneText}</span>
            </button>

          </div>

        </div>

        <div>
            <button
                tabindex="0"
                type="button"
                class="primary-button is-bg-none p-0 right-column-remove-selected-btn"
                aria-label="remove-selected-btn"
            >
                <span data-i18n-key="removeSelected">${removeSelectedText}</span>
            </button>
        </div>
      </div>

      <select multiple class="right-side-options multiselect-options-wrapper">
      </select>

        </div>
        </div>
      </div>`;
  }}
`;

export const multiSelectCardTemplate = htmlE`
  ${({ hidden, label, value }) => {
    return `<option value="${value}"${
      hidden ? " hidden" : ""
    }>${label}</option>`;
  }}
`;

export const hiddenSelectOptionTemplate = htmlE`
  <option selected="true" value="${"value"}">${"label"}</option>
`;
